<template>
  <div class="box">
    <div class="box-header">
      <div class="box-header-start">
        <custom :total="totals" />
      </div>
      <div class="box-header-end">
        <div class="switch-container">
          <label class="label">Show NEW only</label>
          <label class="switch">
            <input @click="
              (CVStatus = !CVStatus),
              querySeeker(),
              $router.push({
                query: { type: $route.query.type, p: 10, q: 1, s: '' },
              })
              " type="checkbox" value="false" v-model="CVStatus" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <table class="table">
      <thead class="sticky">
        <tr>
          <th class="is-xs">NO</th>
          <th class="is-xs">Photo</th>
          <th>Full Name</th>
          <th>Email</th>
          <th>Job Level</th>
          <th class="is-sm">Update CV</th>
          <th class="is-xxs">Point</th>
          <th class="is-xxs text-center">Status</th>
          <th class="is-xxs text-center">Show CV</th>
        </tr>
      </thead>
      <!-- @click="openNewTab(js._id)" -->
      <!-- @click="$router.push({name:'jobseeker-view', params:{id:js._id}})" -->
      <tbody v-for="(js, idx) in seekers" :key="idx">
        <tr :class="{ read: js.CVStatus }">
          <td class="is-xs">{{ idx + 1 }}</td>
          <td class="is-xs" @click="openNewTab(js._id)">
            <div v-if="js" class="photo" :style="{
              'background-image': 'url(' + js.profile + ')',
            }"></div>
          </td>
          <td class="is-md" v-if="js" @click="openNewTab(js._id)">
            {{ js.firstName }} {{ js.lastName }}
          </td>
          <td @click="openNewTab(js._id)">{{ js.email }}</td>
          <td @click="openNewTab(js._id)">{{ js.jobLevels }}</td>
          <td @click="openNewTab(js._id)">{{ filters(js.updatedAt) }}</td>
          <td class="text-center">{{ js.point }}</td>
          <td class="is-sm text-center">
            <span :class="js.status">{{ js.status }}</span>
          </td>
          <td>
            <div class="show-hide">
              <span class="show" v-if="js.isSearchable" @click="updateisSearchable(js._id, false)">
                <i class="fa-solid fa-square-check"></i>
              </span>
              <span v-else @click="updateisSearchable(js._id, true)">
                <i class="fa-regular fa-square"></i>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import custom from "../Pagination/customPagination";
import { GET_SEEKER, UPDATE_ISSEARCHABLE } from "@/graphql/seeker/seeker";
import { apolloClient } from "@/services/apollo-client";
import moment from "moment";
export default {
  components: {
    custom,
  },
  data: () => ({
    seekers: [],
    totals: null,
    isLoading: false,
    CVStatus: false,
    jobFunctionId: [],
    jobLevelId: []
  }),
  methods: {
    openNewTab(id) {
      const a = document.createElement("a");
      const urlEiei = "/jobseeker/" + id;

      a.href = urlEiei;
      a.target = "_blank";
      a.click();
    },
    async querySeeker() {
      this.isLoading = true;
      const res = await apolloClient.query({
        query: GET_SEEKER,
        variables: {
          type: this.$route.query.type,
          page: parseInt(this.$route.query.q),
          perPage: parseInt(this.$route.query.p),
          search: this.$route.query.s,
          CVStatus: this.CVStatus,
          jobLevelId: this.$route.query.jobLevelId ? this.$route.query.jobLevelId : [],
          skillTagId: this.$route.query.skillTagId ? this.$route.query.skillTagId : [],
          jobFunctionId: this.$route.query.jobFunctionId ? this.$route.query.jobFunctionId : []
        },
      });
      let result = res.data.getRegisterseeker;
      this.seekers = result.getSeeker;
      this.totals = result.totals;
      this.isLoading = false;
    },
    filters: function (date) {
      return moment(date, "YYYY/MM/DD").format("DD/MMM/YY");
    },
    async updateisSearchable(_id, status) {
      const res = await apolloClient.mutate({
        mutation: UPDATE_ISSEARCHABLE,
        variables: {
          _id,
          isSearchable: status,
        },
      });
      this.querySeeker();
    },
  },
  watch: {
    "$route.query": {
      async handler(val) {
        if (val) {
          this.querySeeker();
        }
      },
      // immediate: true,
      // deep: true
    },
  },
  created() {
    this.querySeeker();
  },
};
</script>
<style lang="scss" scoped>
tr {
  cursor: pointer;

  &:hover {
    td {
      color: var(--primary-color);
    }
  }
}

.show-hide {
  display: flex;
  justify-content: center;

  span {
    font-size: var(--lg-font) !important;

    &.show {
      font-weight: 700;
      color: var(--primary-color);
    }

    &.hide {
      color: var(--dark-grey-color);
    }
  }
}

.read td {
  font-weight: bold !important;
  background-color: rgba(var(--primary-color), 0.09) !important;
}

.switch-container {
  display: flex;
  align-items: center;
  gap: 5px;

  label {
    margin: 0;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 26px;
  }
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--light-grey-color);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked+.slider {
  background-color: var(--primary-color);
}

input:checked+.slider:before {
  -webkit-transform: translateX(23px);
  -ms-transform: translateX(23px);
  transform: translateX(23px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 28px;
}

.slider.round:before {
  border-radius: 50%;
}

.is-right {
  margin-left: auto;

  input {
    border: none;
  }
}
</style>
